import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  static values = {
    recordStatuses: Array
  }

  static targets = [
    'measureFrom', 'measureTo'
  ]

  connect () {
    this.updateMeasureFrom()
    this.updateMeasureTo()

    this.boundHandleDropdownChange = this.handleDropdownChange.bind(this)
    document.addEventListener('response-time-removed', this.boundHandleDropdownChange)
  }

  disconnect () {
    document.removeEventListener('response-time-removed', this.boundHandleDropdownChange)
  }

  updateMeasureFrom () {
    // update measureTo dropdown
    if (this.measureToTarget instanceof HTMLSelectElement) {
      Array.from(this.measureToTarget.options).forEach(measureToOption => {
        if (measureToOption.value !== '' && measureToOption.value === this.measureFromTarget.value) {
          measureToOption.disabled = true
        } else {
          measureToOption.disabled = false
        }
      })
    }

    const measureFromElements = Array.from(document.querySelectorAll('[data-target="response-times.measureFrom"]'))
    const reservedMeasureFromElementValues = Array.from(measureFromElements).map(option => option.value).filter(value => value !== '')
    const measureToElements = Array.from(document.querySelectorAll('[data-target="response-times.measureTo"]'))

    Array.from(measureFromElements).forEach((iteratingMeasureFromElement, index) => {
      const reservedValues = reservedMeasureFromElementValues.filter(value => value !== iteratingMeasureFromElement.value)
      const iteratingMeasureToElement = measureToElements[index]

      if (iteratingMeasureToElement.value !== '' && !reservedValues.includes(iteratingMeasureToElement.value)) {
        reservedValues.push(iteratingMeasureToElement.value)
      }

      Array.from(iteratingMeasureFromElement.options).forEach(iteratingMeasureFromElementOption => {
        if (iteratingMeasureFromElementOption.value !== '' && reservedValues.includes(iteratingMeasureFromElementOption.value)) {
          iteratingMeasureFromElementOption.disabled = true
        } else {
          iteratingMeasureFromElementOption.disabled = false
        }
      })
    })
  }

  updateMeasureTo () {
    if (this.measureFromTarget instanceof HTMLSelectElement) {
      const measureFromElements = Array.from(document.querySelectorAll('[data-target="response-times.measureFrom"]'))
      const reservedMeasureFromElementValues = Array.from(measureFromElements).map(option => option.value).filter(value => value !== '')

      if (!reservedMeasureFromElementValues.includes(this.measureToTarget.value)) {
        reservedMeasureFromElementValues.push(this.measureToTarget.value)
      }

      Array.from(this.measureFromTarget.options).forEach(option => {
        if (option.value !== '' && reservedMeasureFromElementValues.includes(option.value) && option.value !== this.measureFromTarget.value) {
          option.disabled = true
        } else {
          option.disabled = false
        }
      })
    }
  }

  handleDropdownChange (event) {
    this.updateMeasureFrom()
    this.updateMeasureTo()
  }
}
